export default {"footerNavGroupWrapper":"ipRmT","footerNavSubLinks":"GD6D-","open":"vLQtz","subLink":"wk--4 H9fHT UzvkT","subLinkItem":"ZCJI7"};